<template>
  <div class="search-box">
    <el-form ref="form" :inline="true" :model="ruleForm" size="mini"  :rules="rules" class="demo-form-inline">
      <el-form-item label="接口服务时间:" prop="date">
        <date-time-range @changeDateTime="changeDateTime"/>
      </el-form-item>
      <el-form-item label="用户机构：" prop="organization">
        <dep-code-tree @change="handleChange"></dep-code-tree>
      </el-form-item>
      <el-form-item label="操作类型：" prop="portType">
        <el-select v-model="ruleForm.portType" placeholder style="max-width:180px;">
          <el-option
            v-for="item in typeList"
            :key="item.id"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="用户名称：" prop="userName">
        <el-input v-model="ruleForm.userName" style="max-width:180px;"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" @click="submit">查询</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import dateTimeRange from '../comm/dateTimeRange';
import depCodeTree from '@/views/comm/depCodeTree';

export default {
  name: 'search',
  components: {
    dateTimeRange,
    depCodeTree
  },
  data() {
    return {
      ruleForm: {
        organization: '',
        startDate: '',
        endDate: '',
        portType: '',
        userName: ''
      },
      rules: {},
      typeList: [
        {
          label: '全部',
          value: ''
        },
        {
          label: '登录',
          value: '0'
        },
        {
          label: '查询',
          value: '1'
        },
        {
          label: '新增',
          value: '2'
        },
        {
          label: '修改',
          value: '3'
        },
        {
          label: '删除',
          value: '4'
        },
        {
          label: '打印',
          value: '5'
        },
        {
          label: '导出',
          value: '6'
        }
      ]
    };
  },
  methods: {
    changeDateTime(date) {
      Object.assign(this.ruleForm, this.ruleForm, date);
    },
    handleChange(arry) {
      if (arry.length > 0) {
        this.ruleForm.depCode = arry[arry.length - 1];
      }
      else {
        this.ruleForm.depCode = '';
      }
    },
    submit() {
      this.$refs['form'].validate(valid => {
        if (valid) {
          this.$emit('getSystemList', this.ruleForm);// emit
        }
        else {
          return false;
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
</style>
